export default __webpack_public_path__ + "static/media/artwork-card-2.76521716.png";